//#region src/pageTitles.ts
var e = {
	HOME: "Home",
	AUTH: {
		LOGIN: "Log in",
		REGISTER: "Create account",
		VERIFY_OTP: "Verify code",
		FORGOT_PASSWORD: "Reset password"
	},
	DASHBOARD: "Dashboard",
	SEARCH: {
		ROOT: "Search",
		ASSISTANT: "Search with Maat"
	},
	PROPERTIES: {
		ROOT: "Properties",
		MAP: "Property map",
		CREATE: "New property",
		RESUME_DRAFT: "New property",
		DETAILS: "Property",
		PREVIEW: "Preview",
		EDIT_IMAGES: "Edit photos",
		EDIT_AMENITIES: "Edit amenities",
		EDIT_PRICING: "Edit pricing",
		EDIT_HOUSE_RULES: "House rules",
		EDIT_QUICK_RULES: "Quick rules",
		EDIT_AUTOMATED_MESSAGES: "Automated messages",
		EDIT_ASSIGNED_RULES: "Manage rules",
		EDIT_NAME: "Edit name",
		EDIT_FACILITIES: "Edit facilities",
		CALENDAR_SYNC_FEED_DETAILS: "Calendar sync",
		MANAGE_LISTINGS: "Manage listings",
		ADD_UNIT: "Add unit",
		AMENITIES: "Amenities",
		LISTING: "Stay",
		PUBLIC: "Stay",
		BOOKING: "Book"
	},
	UNITS: {
		ROOT: "Units",
		EDIT: "Edit unit",
		ADD_LISTING: "Add listing",
		ADD_ROOMS: "Add rooms",
		DETAILS: "Room type"
	},
	ROOMS: {
		ROOT: "Rooms",
		DETAILS: "Room"
	},
	LISTINGS: {
		ROOT: "Listings",
		EDIT_IMAGES: "Edit photos",
		EDIT_AMENITIES: "Edit amenities",
		EDIT_PRICING: "Edit pricing",
		EDIT_HOUSE_RULES: "House rules",
		EDIT_QUICK_RULES: "Quick rules",
		EDIT_AUTOMATED_MESSAGES: "Automated messages",
		EDIT_ASSIGNED_RULES: "Manage rules"
	},
	PROPERTY_GROUPS: {
		ROOT: "Property groups",
		CREATE_GROUP: "New property group",
		DETAILS: "Property group",
		EDIT: "Edit property group"
	},
	EXPERIENCES: {
		ROOT: "Experiences",
		CREATE: "New experience",
		DETAILS: "Experience",
		EDIT: "Edit experience",
		SESSIONS: "Sessions",
		LISTING: "Experience"
	},
	SERVICES: {
		ROOT: "Services",
		CREATE: "New service",
		DETAILS: "Service",
		EDIT: "Edit service",
		SESSIONS: "Sessions",
		LISTING: "Service"
	},
	BOOKINGS: {
		ROOT: "Bookings",
		DETAILS: "Booking",
		REQUESTS: "Booking requests",
		CALENDAR: "Booking calendar",
		RULES: "Booking rules",
		CREATE_RULE: "New booking rule",
		EDIT_RULE: "Edit booking rule",
		RULE_DETAILS: "Booking rule"
	},
	FRONT_DESK: {
		ROOT: "Front desk",
		TODAY: "Today"
	},
	PRICING: {
		ROOT: "Pricing",
		RULES: "Pricing rules",
		CREATE_RULE: "New pricing rule",
		EDIT_RULE: "Edit pricing rule",
		RULE_DETAILS: "Pricing rule",
		RATES: "Rates & availability",
		RATES_BULK: "Bulk edit rates"
	},
	COUPONS: {
		ROOT: "Coupons",
		CREATE: "New coupon",
		DETAILS: "Coupon",
		EDIT: "Edit coupon"
	},
	TRAVEL_GUIDES: {
		ROOT: "Travel guides",
		CREATE: "New travel guide",
		EDIT: "Edit travel guide"
	},
	FINANCE: {
		ROOT: "Finance",
		EARNINGS: "Earnings",
		WITHDRAWALS: "Withdrawals",
		WITHDRAWAL_DETAILS: "Withdrawal",
		WITHDRAWAL_METHODS: "Withdrawal methods",
		WITHDRAWAL_METHOD_CREATE: "New withdrawal method",
		WITHDRAWAL_METHOD_EDIT: "Edit withdrawal method",
		INVOICES: "Invoices",
		PENALTY: "Penalty",
		PENALTY_DETAIL: "Penalty",
		PENALTIES: "Penalties"
	},
	TRIPS: {
		ROOT: "Trips",
		DETAILS: "Trip",
		REVIEW: "Leave a review"
	},
	PAYMENTS: {
		ROOT: "Payments",
		SUCCESS: "Payment successful",
		FAILED: "Payment failed",
		NATIVE_RETURN: "Payment"
	},
	FAVORITES: { ROOT: "Favorites" },
	GUIDES: {
		ROOT: "Travel guides",
		DESTINATION: "Guides by destination",
		DETAILS: "Travel guide"
	},
	HOSTS: {
		ROOT: "Hosts",
		PROFILE: "Host",
		LISTINGS: "Host listings",
		GUIDES: "Host guides",
		REVIEWS: "Host reviews"
	},
	CHAT: "Chat",
	MESSAGES: {
		ROOT: "Messages",
		CONVERSATION: "Messages",
		MATCH: "Messages"
	},
	NOTIFICATIONS: "Notifications",
	ACTIONS: "Action Center",
	WORKSPACES: {
		ROOT: "Workspaces",
		CREATE: "New workspace",
		INVITE: "Invite member",
		MEMBERS: "Members",
		MEMBER_PERMISSIONS: "Member permissions",
		ROLES: "Roles",
		CREATE_ROLE: "New role",
		ROLE_DETAILS: "Role",
		EDIT_ROLE: "Edit role",
		SETTINGS: "Workspace settings",
		SETTINGS_GENERAL: "General settings",
		SETTINGS_VERIFICATION: "Verification settings",
		SETTINGS_BILLING: "Billing settings",
		SETTINGS_NOTIFICATIONS: "Notification settings",
		SETTINGS_INTEGRATIONS: "Integrations",
		SETTINGS_OPERATIONS: "Operations settings",
		SETTINGS_DEVELOPER: "Developer",
		SETTINGS_DEVELOPER_TERMS: "Developer Terms",
		SETTINGS_DEVELOPER_ISSUE_KEY: "Issue developer key"
	},
	DEVELOPER: {
		ROOT: "Developer",
		KEYS: "API keys",
		KEYS_NEW: "Issue developer key",
		WEBHOOKS: "Webhooks",
		WEBHOOKS_REGISTER: "Register webhook endpoint",
		LOGS: "API logs",
		SANDBOX: "Sandbox",
		TERMS: "Developer Terms"
	},
	INVITES: "Invitations",
	INVITE: "Your invite",
	ID_NOTICE: "An ID in your name",
	VERIFICATION: { CALLBACK: "Checking your ID" },
	CREATOR: {
		ROOT: "Creator Portal",
		LINKS: "Links",
		LINK_NEW: "New link",
		LINK_DETAILS: "Link performance",
		EARNINGS: "Earnings",
		WITHDRAWAL_METHODS: "Withdrawal methods",
		WITHDRAWAL_METHOD_NEW: "Add withdrawal method",
		SOCIAL_LINKS: "Social links"
	},
	ADMIN: {
		ROOT: "Admin",
		LOGIN: "Admin login",
		DASHBOARD: "Admin dashboard",
		INSIGHTS: "Insights",
		SATISFACTION: {
			ROOT: "Satisfaction",
			OVERVIEW: "Satisfaction",
			RESPONSES: "Satisfaction responses"
		},
		HEALTH: "System health",
		VERIFICATIONS: {
			ROOT: "Verifications",
			DETAILS: "Verification"
		},
		AREAS: {
			ROOT: "Areas",
			NEW: "New area",
			DETAILS: "Area",
			EDIT: "Edit area"
		},
		POPULAR_FILTERS: { ROOT: "Popular filters" },
		MARKETING: {
			ROOT: "Marketing",
			NEW: "New marketing asset",
			DETAILS: "Marketing asset",
			EDIT: "Edit marketing asset"
		},
		NOTIFICATIONS: {
			ROOT: "Notifications",
			TEMPLATES: "Notification templates",
			TEMPLATE_EDIT: "Edit notification template",
			ANALYTICS: "Notification analytics"
		},
		FINANCE: { ROOT: "Finance" },
		PAYOUTS: {
			ROOT: "Payouts",
			DETAILS: "Payout"
		},
		CREATOR_PAYOUTS: { ROOT: "Creator payouts" },
		COUPONS: {
			ROOT: "Coupons",
			NEW: "New coupon",
			DETAILS: "Coupon",
			EDIT: "Edit coupon"
		},
		PARTNERS: {
			ROOT: "Creator partners",
			NEW: "New partner",
			DETAILS: "Partner",
			EDIT: "Edit partner",
			LINK_NEW: "New partner link",
			LINK_EDIT: "Edit partner link",
			LINK_DETAILS: "Link performance",
			APPLICATIONS: "Partner applications",
			APPLICATION_REVIEW: "Review application"
		},
		COUPON_DEFICITS: { ROOT: "Coupon deficits" },
		UNIT_CHANGE_DEFICITS: { ROOT: "Unit change deficits" },
		RULE_TEMPLATES: {
			ROOT: "Rule templates",
			NEW: "New rule template",
			EDIT: "Edit rule template"
		},
		USERS: {
			ROOT: "Users",
			DETAILS: "User",
			EDIT: "Edit user"
		},
		WORKSPACES: {
			ROOT: "Workspaces",
			DETAILS: "Workspace",
			DECLINE_DEVELOPER_ACCESS: "Decline developer access",
			REVOKE_DEVELOPER_ACCESS: "Revoke developer access",
			DEVELOPER_KEY_RATE_LIMIT: "Key rate limit"
		},
		LISTINGS: {
			ROOT: "Listings",
			DETAILS: "Listing",
			EDIT_PRICING: "Edit pricing",
			EDIT_AMENITIES: "Edit amenities",
			EDIT_UNIT_DETAILS: "Edit unit details"
		},
		LISTING_MODERATION: { ROOT: "Listing review" },
		IMAGE_MODERATION: { ROOT: "Image moderation" },
		TRAVEL_GUIDES: {
			ROOT: "Travel guides",
			REVIEW: "Review travel guide"
		},
		BOOKINGS: {
			ROOT: "Bookings",
			DETAILS: "Booking",
			CHANGE_UNIT: "Change unit"
		},
		SUPPORT: {
			ROOT: "Support",
			TICKET_DETAILS: "Support ticket",
			ARTICLES: {
				ROOT: "Help articles",
				NEW: "New article",
				EDIT: "Edit article"
			},
			CATEGORIES: "Help categories",
			FAQS: {
				ROOT: "FAQs",
				NEW: "New FAQ",
				EDIT: "Edit FAQ"
			},
			CALLBACKS: "Callback requests"
		},
		AI_CONVERSATIONS: {
			ROOT: "AI conversations",
			OVERVIEW: "AI conversations",
			CONVERSATIONS: "AI conversations",
			DETAILS: "AI conversation"
		},
		AI_GENERATIONS: { ROOT: "AI generations" },
		OPERATIONS: {
			FEEDS: "Feeds",
			FEED_DETAILS: "Feed",
			DLQ: "Dead-letter queue",
			ANNOUNCEMENTS: "Announcements",
			ANNOUNCE: "New announcement"
		},
		DEVELOPER: {
			DLQ: "Dead-letter queue",
			LAMBDAS: "Lambda failures",
			ROUTING_TELEMETRY: "Routing telemetry",
			PAYMENT_INBOX: "Payment inbox",
			DIDIT_INBOX: "Didit inbox",
			AKEDLY_INBOX: "Akedly inbox",
			PHONE_AUTH: "Phone auth",
			PRICELABS_INBOX: "PriceLabs inbox",
			PRICELABS_HEALTH: "PriceLabs sync health",
			PLATFORM: "Developer platform",
			DEVELOPERS: "Developers",
			DEVELOPER_DETAILS: "Developer",
			PARTNER_DELIVERIES: "Webhook deliveries",
			PARTNER_REQUESTS: "Developer API requests",
			ACCESS_REQUESTS: "Developer access requests",
			OUTBOX: "Outbox",
			CRON: "Cron jobs",
			MEDIA_PIPELINE: "Media pipeline",
			VERSION: "Version",
			LAUNCH_GATES: "Launch gates",
			API_KEYS: "API keys",
			API_KEYS_NEW: "Issue API key",
			MCP_KEYS: "Claude (MCP) access",
			MCP_KEYS_NEW: "Connect Claude",
			SLACK: "Slack assistant",
			SLACK_OPERATOR_NEW: "Add Slack operator",
			SLACK_CHANNEL_NEW: "Allow Slack channel"
		},
		ADMINS: {
			ROOT: "Admins",
			INVITE: "Invite admin"
		}
	},
	ACCOUNT: {
		ROOT: "Account",
		GETTING_STARTED: "Getting started",
		DETAILS: "Account details",
		SECURITY: "Security",
		NOTIFICATIONS: "Notification settings",
		PRIVACY: "Privacy",
		LANGUAGE: "Language",
		PAYMENT_METHODS: "Payment methods",
		IDENTITY_VERIFICATION: "Identity verification",
		LOGIN: "Login & security",
		HELP: "Help",
		COUPONS: "My coupons",
		CREATOR_PARTNER: "Creator partner"
	},
	HELP: {
		ROOT: "Help center",
		CATEGORY: "Help",
		ARTICLE: "Help article",
		FAQ: "FAQs",
		CONTACT: "Contact support",
		CONTACT_PENDING: "Contact support",
		CALLBACK: "Request a callback"
	},
	ABOUT: "About",
	HOST_WITH_US: "Become a host",
	LEGAL: {
		TERMS: "Terms of service",
		PRIVACY: "Privacy policy"
	}
};
//#endregion
export { e as PAGE_TITLE };
